export const mapboxToken =
  "pk.eyJ1IjoiamZtYXNzIiwiYSI6ImNqbGtlazNpbzBtMHEzd3BocWtvbmUzYW4ifQ.gWB_qtgbZ8sz_W_VfpTStQ";
